import { useState } from "react";

export const useVideoState = () => {
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [buffering, setBuffering] = useState(false);
  const [buffered, setBuffered] = useState<TimeRanges | null>(null);
  const [hasStarted, setHasStarted] = useState(false);
  const [isDraggingProgress, setIsDraggingProgress] = useState(false);

  return {
    currentTime,
    setCurrentTime,
    duration,
    setDuration,
    buffering,
    setBuffering,
    buffered,
    setBuffered,
    hasStarted,
    setHasStarted,
    isDraggingProgress,
    setIsDraggingProgress,
  };
};
